<div class="contact-form-container">
  <!-- Cards de aliados en la parte superior -->
  <div class="allies-section">
    <div class="allies-cards">
      <div 
        *ngFor="let ally of allies" 
        class="ally-card"
        (click)="onAllyClick(ally)">
        <img [src]="ally.logo" [alt]="ally.name" class="ally-logo">
      </div>
    </div>
  </div>

  <!-- Texto descriptivo -->
  <div class="form-description">
    <p>Nuestros embajadores de marca se contactarán contigo</p>
  </div>

  <!-- Formulario -->
  <form class="contact-form" (ngSubmit)="onSubmit()">
    <!-- Campo Nombre -->
    <div class="form-group">
      <input 
        type="text" 
        id="nombre"
        name="nombre"
        [(ngModel)]="formData.nombre"
        placeholder="Nombres"
        class="form-input"
        required>
    </div>

    <!-- Campo Apellidos -->
    <div class="form-group">
      <input 
        type="text" 
        id="apellidos"
        name="apellidos"
        [(ngModel)]="formData.apellidos"
        placeholder="Apellidos"
        class="form-input"
        required>
    </div>

    <!-- Campo Descripción -->
    <div class="form-group">
      <textarea 
        id="descripcion"
        name="descripcion"
        [(ngModel)]="formData.descripcion"
        placeholder="Describe tu consulta o duda para ayudarte"
        class="form-textarea"
        rows="4"
        maxlength="200"
        required></textarea>
      <div class="char-counter">{{ getCharCount() }}</div>
    </div>

    <!-- Botón de envío -->
    <button type="submit" class="submit-button">
      Enviar
    </button>
  </form>
</div>
